import { useOktaAuth } from "@okta/okta-react";
import axios from "axios";
import { useQuery } from "@tanstack/react-query";

export function useFetchUserServerSessions(email, from, to, shouldFetch) {
  const { oktaAuth } = useOktaAuth();
  const dataKey = "FetchUserServerSessions";

  return useQuery({
    queryKey: [dataKey, email, from, to],
    queryFn: async ({ signal }) => {
      const accessToken = oktaAuth.getAccessToken();
      const response = await axios.get("api/Telemetry/user-server-sessions", {
        params: { email, from, to },
        headers: { Authorization: `Bearer ${accessToken}` },
        signal,
      });
      return response.data;
    },
    enabled: Boolean(shouldFetch && email && from && to),
    staleTime: 60 * 1000,
    refetchOnWindowFocus: false,
  });
}
